module.exports = __webpack_public_path__ + "4f2f717607837da0cd795120fa238e0f.svg";